import { Box, Text } from '@factorialco/deprecated-design-system'
import capitalize from 'lodash/capitalize'
import moment from 'moment'

import i18n from 'modules/core/lib/i18n'
import { getFullDisplayName } from 'modules/core/lib/userDisplayName'
import users from 'modules/core/store/collections/users'

import type SupplementValidation from 'modules/payroll_bundle/store/models/SupplementValidation'

interface TooltipContentProps {
  currentAccessId: number
  validation: SupplementValidation
}

const TooltipContent = ({ validation, currentAccessId }: TooltipContentProps) => {
  const validatedOn = moment(validation.attributes.created_at).format('L')
  const hasValidated = validation.attributes.author_id === currentAccessId
  const authorUser = users.get(validation.attributes.author_id)
  const authorFullName = authorUser
    ? getFullDisplayName({
        firstName: authorUser.attributes.first_name,
        lastName: authorUser.attributes.last_name,
      })
    : undefined

  return (
    <Box gap="s16" flexDirection="row" justifyContent="spaceBetween">
      <Box flexDirection="row" width="s140">
        <Text.Normal size="200" weight="semibold" ellipsis>
          {authorFullName}{' '}
          {hasValidated &&
            `(${capitalize(i18n.t('payroll_bundle.supplements.supplement_validations.you'))})`}
        </Text.Normal>
      </Box>
      <Text.Normal size="200" weight="semibold">
        {validatedOn}
      </Text.Normal>
    </Box>
  )
}

export default TooltipContent
